/**
 * Axios Instance with Interceptors
 * Provides centralized request/response handling
 */

import axios from 'axios';
import { API_BASE_URL } from './apiConfig';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000, // 15 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add auth token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor - handle common errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized - user session expired
    if (error.response?.status === 401) {
      console.warn('Unauthorized request - clearing token');
      localStorage.removeItem('token');
      
      // Only redirect if not already on login/signup pages
      const currentPath = window.location.pathname;
      if (!['/login', '/signup', '/forgot-password', '/reset-password'].includes(currentPath)) {
        window.location.href = '/login';
      }
    }
    
    // Handle network errors
    if (error.code === 'ERR_NETWORK' || error.message?.includes('Network Error')) {
      console.error('Network error - check backend connection');
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
